import Generic from './generic'
import Olympiad from './olympiad'

class Participation extends Generic {
  constructor({ olympiad, ...attributes }) {
    super(attributes)

    this._receivedOn = new Date()
    this._olympiad = olympiad ? new Olympiad(olympiad) : null
  }

  get olympiad() { return this._olympiad }
  get canBeStarted() { return this.can_be_started }
  get canBeRestarted() { return !!this.malfunctionInterval }
  get startedAt() { return this.started_at }
  get timeLeft() { return this.time_left }
  get receivedOn() { return this._receivedOn }
  get hasStarted() { return !!this.startedAt }

  get timeRemaining() {
    const remaining = this.timeLeft - (new Date() - this.receivedOn) / 1000
    return remaining > 0 ? remaining : 0
  }

  get isSolving() {
    return (
      this.hasStarted && this.timeLeft > 0 && this.timeRemaining > 0
    )
  }

  get hasSolved() {
    return (
      this.hasStarted && (this.timeLeft === 0 || this.timeRemaining === 0)
    )
  }

  get isAwardee() { return !!this.prize }

  get malfunctionInterval() { return this.malfunction_interval }
}

export default Participation
